import React, { PureComponent } from 'react';
import location from '../services/location';
import Loading from '../components/Layout/Loading';

interface IAuthorizeProps {
    login: () => Promise<{
        isLogged: boolean;
        redirectUri?: string;
    }>;
}

interface IAuthorizeState {
    isLoading: boolean;
}

class Authorize extends PureComponent<IAuthorizeProps, IAuthorizeState> {
    state = {
        isLoading: true,
        isLoggedIn: false,
    };

    /**
     * any exception should be captured in a parent function
     */
    async componentDidMount() {
        const res = await this.props.login();
        if (res.isLogged) {
            this.setState({ isLoading: false });
        } else {
            location.href = res.redirectUri as string;
        }
    }

    render() {
        if (this.state.isLoading) {
            return <Loading />;
        }

        return <>{this.props.children}</>;
    }
}

export default Authorize;
